<template>
  <div class="about TopHeadder">
      <!-- 关于我们 -->
      <div class="bannerBox">
          <img src="../assets/image/ab_banner.png" />
           <div class="bannerTitle">
             <h3>小语智能</h3>
             <p>生意成交更容易 客户服务更便</p>
          </div>
      </div>

      <div class="about_item1 PublicPadding">
          <h4 class="title">关于小语</h4>
          <div class="about_txtBox">
                <p>杭州智语网络科技有限公司（以下简称“小语智能”）是一家依托于浙江大学计算机学院，专注智能客服营销及大 数据创新服务的高新技术企业。</p>
                <p>小语智能是基于16年通讯领域从业经验和技术积累重组而成。公司核心成员均来自浙江大学、阿里巴巴等知名校、 企，科研团队由众多人工智能领域教授、博士、硕士组成，具有极强的智能服务营销研发实力和创新能力。 小语智能自成立以来，以智能语音AI为基础，获得多项国家发明专利及软件著作权。打造出“智能语音外呼机器 人”、“电销外呼系统”、“企业智能客服软件系统”、“语音中间件平台”等一系列企业客服营销产品，帮助企 业效益最大化，推动企业业务创新。同时小语智能与硅谷顶尖大数据团队合作，帮助大数据中台在国内的落地实 践，成功落地多个大数据项目，帮助企业实现基于“决策+产品+运营”数据支持的数字化运营，以高质量的快速 交付赢得客户高度赞誉。</p>
                <p>2018年3月，小语智能完成天使轮融资；2018年10月，顺利完成千万级Pre-A轮融资。</p>
          </div>
      </div>
      <div class="PublicPadding y_t">
          <h4 class="title">发展历程</h4>
          <div>
            <div class="y_item"> 
              <h3>2020年</h3>
              <ul>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>05月</h4>
                      </i>
                      <p>2020.05小语智能“基于语音识别后的关键词匹配和应答路径的意向识别方法”获得国家发明专利;</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>03月</h4>
                      </i>
                      <p>2020.03 小语智能电话外呼系统易营销全新升级上线；</p>
                  </li>
              </ul>
            </div>
             <div class="y_item"> 
              <h3>2019年</h3>
              <ul>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>12月</h4>
                      </i>
                      <p>2019.12小语智能被评为杭州市高新技术企业；</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>05月</h4>
                      </i>
                      <p>2019.05小语智能商机宝发布上线；</p>
                  </li>
                   <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>03月</h4>
                      </i>
                      <p>2019.03 小语智能客服平台V3.0完成技术升级；</p>
                  </li>
              </ul>
            </div>
             <div class="y_item"> 
              <h3>2018年</h3>
              <ul>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>12月</h4>
                      </i>
                      <p>2018.12 小语智能成功入选“5050计划”；</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>10月</h4>
                      </i>
                      <p>2018.10 小语智能完成千万级Pre-A轮融资；</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>05月</h4>
                      </i>
                      <p>2018.05 小语智能语音机器人发布上线；</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>04月</h4>
                      </i>
                      <p>2018.04 小语智能完成天使轮融资；</p>
                  </li>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <img src="../assets/image/a_2.png" class="y_img2"/>
                        <h4>03月</h4>
                      </i>
                      <p>2018.03 小语智能从杭州领先拆分成立，专注AI技术与客服产品研发；</p>
                  </li>
              </ul>
            </div>
             <div class="y_item"> 
              <h3>2004年</h3>
              <ul>
                  <li>
                      <i>
                        <img src="../assets/image/a_1.png" class="y_img1"/>
                        <h4>11月</h4>
                      </i>
                      <p>2004.11 小语智能前身——杭州领先科技成立；</p>
                  </li>
                
              </ul>
            </div>
          </div>
      </div> 
      <div class="aboutPublic mTop20">
          <!-- <img class="swiper_bg" src="../assets/image/about_swiper_bg.jpg" /> -->
          <h4 class="title">团队介绍</h4>  
          <div class="about_swiper1">
              <swiper :options="swiperOption1">
                  <swiper-slide>
                      <div class="ateam_t2">
                            <i><img src="../assets/image/img_1_lvshao.png" /></i>
                            <h4>吕韶</h4>
                            <span>联合创始人兼CEO</span>
                            <s></s>
                        </div>
                        <p>浙江大学计算机研究生毕业，人工智能专家，连续创业者，先后创办了杭州领先科技、杭州每日科技、杭州智语网络科技。拥有十多年TO B服务市场行业经验，具备极强的战略规划及创新能力。</p>
                    <!-- <img src="../assets/image/about_swiper1_pic1.png"> -->
                  </swiper-slide>
                  <swiper-slide>
                        <div class="ateam_t2">
                            <i><img src="../assets/image/img_2_wuchunming.png" /></i>
                            <h4>吴春明</h4>
                            <span>联合创始人兼首席科学家</span>
                            <s></s>
                        </div>
                        <p>浙江大学教授/博导，曾主持参与了十多项国家973、863课题、国家自然科学基金项目等研究与开发工作。现为国家“十二五”863信息领域专家组专家，中国SDN与开放网络专业委员会主任委员，浙江省“新世纪151人才工程”培养人选，浙江大学青年学术带头人。</p>
                   
                    <!-- <img src="../assets/image/about_swiper1_pic2.png"> -->
                  </swiper-slide>
                  <swiper-slide>
                       <div class="ateam_t2">
                            <i><img src="../assets/image/img_3_xuzhangsheng.png" /></i>
                            <h4>徐路生</h4>
                            <span>联合创始人兼营销总监</span>
                            <s></s>
                        </div>
                        <p>
                            资深互联网专家，曾参与创办E都市、房途网、租房宝项目等。2013年创办杭州微巴，
                            短短两年创造了从2人1.8万启动资金发展成500人年营业额上亿元的佳绩。拥有强大
                            的招商、运营、策划及企业管理经验。
                        </p>
                    <!-- <img src="../assets/image/about_swiper1_pic3.png"> -->
                  </swiper-slide>
                  <!--<swiper-slide><img src="../assets/image/about_swiper1_pic5.png"></swiper-slide>
                  <swiper-slide><img src="../assets/image/about_swiper1_pic7.png"></swiper-slide>-->

              </swiper>
              <!--以下看需要添加-->
              <div class="swiper-button-next swiper1-next" data-alt="下一项"></div>
              <div class="swiper-button-prev swiper1-prev" data-alt="上一项"></div>
          </div>
      </div>
 
      <div class="about_item2 PublicPadding">
          <h4 class="title">公司荣誉</h4>
          <ul>
             <li :class="{active:activeChild==1}" v-on:click="activeTab(1)">
                <p>软件著作权</p>
             </li>
             <li :class="{active:activeChild==2}" v-on:click="activeTab(2)">
                <p>发明专利</p>
             </li>
             <li :class="{active:activeChild==3}" v-on:click="activeTab(3)">
                <p>企业荣誉证书</p>
             </li>
          </ul>
          <ol>
             <li v-show="activeChild==1">
                 <div class="about_swiper2">
                    <swiper :options="swiperOption2">
                        <swiper-slide><img src="../assets/image/rz_1.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_2.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_3.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_4.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_5.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_6.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_7.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_8.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_9.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_10.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_11.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_12.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_13.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_14.jpg"></swiper-slide>
                        <swiper-slide><img src="../assets/image/rz_15.jpg"></swiper-slide>
                    </swiper>
                    <!--以下看需要添加-->
                    <div class="swiper-button-next swiper2-next" data-alt="下一项"></div>
                    <div class="swiper-button-prev swiper2-prev" data-alt="上一项"></div>
                </div>
             </li>
             <li v-show="activeChild==2">
                  <i class="fm">
                    <img src="../assets/image/fm_1.jpg"/>
                  </i>
                 
             </li>
             <li v-show="activeChild==3">
                <div class="ry">
                  <i>
                    <img src="../assets/image/ry_1.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_2.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_3.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_4.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_5.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_6.jpg"/>
                  </i>
                  <i>
                    <img src="../assets/image/ry_7.jpg"/>
                  </i>
                </div>
             </li>
          </ol> 
      </div>
      <div class="about_item3 PublicPadding">
         <h4 class="title">联系我们</h4>
         <div class="at3_text">
            <ul>
                <li class="at3_li1">
                    <i><img src="../assets/image/ab3_1.png"/></i>
                    <h3>公司地址：</h3>
                    <p>杭州市西湖区文二路西湖国际科技大厦E中416-418室</p>
                </li>
                <li class="at3_li2">
                    <i><img src="../assets/image/ab3_2.png"/></i>
                    <h3>联系电话：</h3>
                    <p>0571-28179999</p>
                </li>
                <li class="at3_li3">
                    <i><img src="../assets/image/ab3_3.png"/></i>
                    <h3>售前咨询：</h3>
                    <p>186 6790 8789</p>
                </li>
            </ul>
            <i class="map"><img src="../assets/image/map.png"/></i>
         </div>
      </div>
      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Popup from "@/components/popup"
export default {
  name: 'about',
  data () {
    return { 
      activeChild:1,
      swiperOption1: {
        autoplay:true,
        speed: 500,
        loop:true,
        slidesPerView: 'auto',
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper1-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper1-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'swiper1-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'swiper1-button-hidden', //按钮隐藏时的Class
        },
      },
      swiperOption2: {
        autoplay:true,
        speed: 500,
        loop:true,
        slidesPerView: 3,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper2-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper2-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'swiper2-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'swiper2-button-hidden', //按钮隐藏时的Class
        },
		  },
    
    }
  },
  components:{
    swiper,
    swiperSlide,
    Popup
  },
  methods:{
     popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
     },
     activeTab(num) {
       this.activeChild=num
     },
  }
}
</script>


<style scoped>
.bannerTitle h3{
   text-align: left;
}
.about_item1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.about_txtBox{
  padding: 0.4rem;
  box-shadow: 0 0 0.08rem #ccc;
  margin-top: 0.5rem;
  margin-bottom: 0.7rem;
}
.about_txtBox p{
  margin-top: 0.34rem;
  font-size: 0.22rem;
  color:#808080;
}

.aboutPublic{
  height:8.8rem;
  overflow: hidden;
  position: relative;
  background: #fff;
}
.aboutPublic .swiper_bg{
  width: 100%;
  min-height:10.1rem;
}
.aboutPublic .title{
  color: #333;
  width: 100%;
  position: absolute;
  top: 0.88rem;
  left: 0;
  z-index:33;
}
.aboutPublic .ateam_t2{
  width: 2.5rem;
  margin: 0 auto;
  padding: 0.2rem 0;
  margin-top:0.3rem;
}
.aboutPublic .ateam_t2 i{
  display: block;
  width: 0.91rem;
  height: 0.91rem;
  margin: 0 auto;
}
.aboutPublic .ateam_t2 i img{
  display: block;
  width: 0.91rem;
  height: 0.91rem;
}
.aboutPublic .ateam_t2 h4{
  color: #333;
  font-size: 0.24rem;
  text-align: center;
  margin: 0.2rem 0;
}
.aboutPublic .ateam_t2 span{
  display: block;
  color: #333;
  font-size: 0.2rem;
  text-align: center;
}
.aboutPublic .ateam_t2 s{
  display: block;
  width: 0.5rem;
  height: 0.05rem;
  background: #00CCFF;
  margin: 0 auto;
  margin-top:0.2rem;
  margin-bottom:0.2rem;
}
.aboutPublic .swiper-slide p{
  font-size: 0.2rem;
  color: #666;
  line-height: 0.3rem;
  padding: 0  0.4rem;
}
/*轮播1-样式*/
.about_swiper1{
  width: 100%;
  height: 6rem;
  position: relative;
}
.aboutPublic .about_swiper1{
  position: absolute;
  top: 2.2rem;
  left: 0;
  z-index:33;
}
.about_swiper1 .swiper-container{
  width: 5.2rem;
  height: 5.65rem;
  border-radius:0.3rem;
  box-shadow: 0 0 0.08rem #ccc;
}
.about_swiper1 .swiper-wrapper img{
  width: 100%;
}
/* .about_swiper1 .swiper-button-next{
  background: url(../assets/image/about_swiper1_right.png) no-repeat;
  right: 0.3rem;
}
.about_swiper1 .swiper-button-prev{
  background: url(../assets/image/about_swiper1_left.png) no-repeat;
  left: 0.3rem;
} */
.about_swiper1 .swiper-button-next,.about_swiper1 .swiper-button-prev{
  width: 0.66rem;
  height: 0.66rem;
  margin-top: -0.33rem;
  background-size:100% 100%;
}

/*轮播2-样式*/
.about_swiper2{
  height: 2.4rem;
  margin-top: 0.56rem;
  position: relative;
}
.about_swiper2 .swiper-container{
  width: 5.85rem;
  height: 2.4rem;
  background: #fff;
  padding: 0.2rem 0;
}
.about_swiper2 .swiper-wrapper img{
  width: 1.8rem;
  margin: 0 auto;
}
.about_swiper2 .swiper-button-next{
  background: url(../assets/image/about_swiper2_right.png) no-repeat;
  right: 0.3rem;
}
.about_swiper2 .swiper-button-prev{
  background: url(../assets/image/about_swiper2_left.png) no-repeat;
  left: 0.3rem;
}
.about_swiper2 .swiper-button-next,.about_swiper2 .swiper-button-prev{
  width: 0.18rem;
  height: 0.36rem;
  margin-top: -0.18rem;
  background-size:100% 100%;
}

.y_item{
  padding-left:0.34rem;
  margin-top:-0.3rem;
}
.y_item h3{
   color:#307EFF;
   padding-left:1.2rem;
}
.y_item ul li{
  overflow:hidden;
 margin-top:-0.1rem;
}
.y_item ul li i{
  display:block;
  float:left;
   width:0.95rem;
    position:relative;
}
.y_item ul li i .y_img1{
   width:0.95rem;
   height:0.95rem;
}
.y_item ul li i .y_img2{
   width:0.53rem;
   height:0.87rem;
   margin-left:0.22rem;
   margin-top:-0.05rem;
}
.y_item ul li h4{
  position:absolute;
  top:0.3rem;
  left:0.2rem;
  color:#fff;
}
.y_item ul li p{
  font-size:0.2rem;
  color:#666;
  margin-top:0.2rem;
  padding-left:1.2rem;
  padding-right:0.2rem;
}
.y_t{
  margin-top:0.2rem;
}
.y_t .title{
  margin-bottom:0.6rem;
}
.about_item2{
  background:url("../assets/image/ab2_bg.png") no-repeat center;
  background-size:100% 100%;
  height: 8.31rem;
}
.about_item2 .title{
  color: #fff;
}
.about_item2 ul{
  overflow: hidden;
  width: 6rem;
  margin:0 auto;
  margin-top:0.4rem;
}
.about_item2 ul li{
  float: left;
  width: 2rem;
  text-align: center;
  font-size: 0.24rem;
  color: #fff;
  padding-bottom: 0.2rem;
}
.about_item2 ul li.active{
  border-bottom: 0.05rem solid #00CCFF;
  color: #00CCFF;
}
.about_item2 ol{
  height: 2rem;
}
.about_item2 .about_swiper2{
  margin-top:1rem;
}
.about_item2 ol .fm{
  display: block;
  width: 1.8rem;
  height: 2.4rem;
  margin: 0 auto;
  margin-top:1rem;
}
.about_item2 ol .fm img{
  display: block;
  width: 1.8rem;
  height: 2.4rem;
}
.about_item2 ol .ry{
  overflow: hidden;
  margin-left:0.08rem;
  margin-top:1rem;
}
.about_item2 ol .ry i{
  display: block;
  width: 1.8rem;
  height: 2.4rem;
  float: left;
  margin-right: 0.05rem;
  margin-top: 0.05rem;
}
.about_item2 ol .ry img{
  display: block;
  width: 1.8rem;
  height: 2.4rem;
}
.about_item3 ul{
  width: 7rem;
  margin: 0 auto;
  box-shadow:0 0 0.08rem #ccc;
  margin-top:0.5rem;
}
.about_item3 ul li{
  height: 1.17rem;
  width: 6.34rem;
  margin: 0 auto;
  border-bottom: 0.01rem solid #ccc;
  overflow: hidden;
  padding-top: 0.3rem;
}

.about_item3 ul li i{
  float: left;
  width:0.18rem;
  height: 0.28rem;
  margin-top:0.1rem;
}
.about_item3 ul li img{
  display: block;
  width:0.18rem;
  height: 0.28rem;
}
.about_item3 ul li h3{
  font-size: 0.16rem;
  font-weight: 400;
  color: #333333;
  line-height: 0.5rem;
  padding-left: 0.4rem;
}
.about_item3 ul li p{
  font-size: 0.24rem;
  color: #666;
  padding-left: 0.4rem;
}
.about_item3 ul li:last-child{
  border:none;
}
.about_item3 .map{
  display: block;
  width: 7.5rem;
  height: 5.5rem;
  margin-top: 0.4rem;
}
.about_item3 .map img{
  display: block;
  width: 7.5rem;
  height: 5.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue